import { getStore } from '~/mobx/AppStore';

export const fetchAdminData = async (): Promise<void> => {
    const { adminStore, companyStore } = getStore();
    const sLagId = companyStore.selectedSlagId;
    if (sLagId) {
        await adminStore.fetchElectionAndRegions(sLagId);
    }
};
